<div
  class="rendered-tree"
  [class.animate]="animate"
  role="region"
  aria-label="Volume relevance decision tree"
>
  <svg
    [attr.viewBox]="'0 0 ' + graph.width + ' ' + graph.height"
    [style.max-width.px]="graph.width"
    class="diagram"
  >
    @for (wire of graph.paths; track $index) {
      <path
        class="connector"
        pathLength="1"
        [style.--flow-step]="
          [
            0, 1, 1, 2, 2, 3, 3, 5, 4, 5, 5, 6, 6, 4, 5, 6, 3, 3, 4, 4, 5, 5, 6,
            6,
          ][$index]
        "
        [class.muted]="wire.muted"
        [attr.d]="wire.path"
      />
      @if (wire.arrow) {
        <polygon
          class="arrowhead"
          [style.--flow-step]="
            [
              0, 1, 1, 2, 2, 3, 3, 5, 4, 5, 5, 6, 6, 4, 5, 6, 3, 3, 4, 4, 5, 5,
              6, 6,
            ][$index]
          "
          [class.muted]="wire.muted"
          points="-17,-9 0,0 -17,9"
          [attr.transform]="
            'translate(' +
            wire.tip[0] +
            ' ' +
            wire.tip[1] +
            ') rotate(' +
            wire.angle +
            ')'
          "
        />
      }
    }
    <foreignObject
      [attr.x]="graph.root[0]"
      [attr.y]="graph.root[1]"
      [attr.width]="graph.root[2]"
      [attr.height]="graph.root[3]"
    >
      <img
        class="tank"
        [src]="assetBasePath + '/' + (graph.ytd ? 'tank-ytd' : 'tank') + '.png'"
        alt=""
      />
    </foreignObject>
    <text
      class="volume-title"
      [attr.x]="graph.title[0]"
      [attr.y]="graph.title[1] + 12"
    >
      Volume Relevance
    </text>
    <foreignObject
      [attr.x]="graph.root[0] + graph.root[2] / 2 - 50"
      [attr.y]="graph.root[1] + graph.root[3] + 14"
      width="100"
      height="24"
    >
      <div class="branch-count" data-count="nodes.volume">
        <span class="pill">{{ graph.rootValue }}</span>
      </div>
    </foreignObject>
    @for (branch of graph.branches; track branch.id) {
      <g [class.muted]="branch.muted" [attr.data-branch]="branch.id">
        <circle
          [attr.cx]="branch.point[0]"
          [attr.cy]="branch.point[1]"
          r="12"
          [attr.fill]="branch.yes ? '#70bd00' : '#dc4146'"
        />
        <text
          class="branch-symbol"
          [attr.x]="branch.point[0]"
          [attr.y]="branch.point[1] + 6"
          [attr.aria-label]="branch.yes ? 'Yes' : 'No'"
        >
          {{ branch.yes ? "&#10003;" : "&#215;" }}
        </text>
      </g>
      @if (!branch.muted || branch.value !== 0) {
        <foreignObject
          [attr.x]="branch.labelPoint[0] - (branch.side ? 0 : 50)"
          [attr.y]="branch.labelPoint[1]"
          width="100"
          height="24"
        >
          <div
            class="branch-count"
            [class.side]="branch.side"
            [attr.data-count]="'branches.' + branch.id"
          >
            <span class="pill">{{ branch.value }}</span>
          </div>
        </foreignObject>
      }
      @if (branch.id === "volume-yes" || branch.id === "volume-no") {
        <text
          class="volume-threshold"
          [attr.x]="branch.point[0] + 25"
          [attr.y]="branch.point[1] + 4"
        >
          {{ branch.yes ? ">1%" : "&#8804;1%" }}
        </text>
      }
    }
    @for (card of graph.cards; track card.id) {
      <foreignObject
        [attr.x]="card.bounds[0]"
        [attr.y]="card.bounds[1]"
        [attr.width]="card.bounds[2]"
        [attr.height]="card.bounds[3]"
      >
        <section
          class="node"
          [class.warning]="card.warning"
          [class.muted-node]="card.muted"
          [attr.data-node]="card.id"
          [attr.aria-label]="
            card.muted && card.value === 0
              ? card.label
              : card.label + ': ' + card.value
          "
        >
          <img
            class="icon"
            [src]="assetBasePath + '/' + card.icon + '.png'"
            alt=""
          />
          <div class="node-label">{{ card.label }}</div>
          @if (card.threshold) {
            <small>(MACO/HL &gt;MACO/HL<br />Threshold)</small>
          }
          @if (card.warning) {
            <span class="warning-symbol" aria-label="YTD warning">&#9888;</span>
          }
          @if (card.id === "recovery" && !hasSellout) {
            <img
              class="recovery-warning"
              src="assets/images/caution-icon.svg"
              alt="Financial Recovery Test is not applicable in Without Sellout flow"
              tabindex="0"
              matTooltip="Financial Recovery Test is not applicable in Without Sellout flow"
              matTooltipPosition="below"
            />
          }
          @if (!card.muted || card.value !== 0) {
            <span
              class="pill node-count"
              [attr.data-count]="'nodes.' + card.id"
              >{{ card.value }}</span
            >
          }
        </section>
      </foreignObject>
    }
    @for (outcome of graph.outcomes; track outcome.id) {
      <foreignObject
        class="output-object"
        [attr.x]="outcome.bounds[0]"
        [attr.y]="outcome.bounds[1]"
        [attr.width]="outcome.bounds[2]"
        [attr.height]="outcome.bounds[3]"
      >
        <section class="outcome" [attr.data-outcome]="outcome.id">
          <img [src]="assetBasePath + '/' + outcome.icon + '.png'" alt="" />
          <span class="outcome-label">{{ outcome.label }}</span>
          <span
            class="outcome-count"
            [attr.data-count]="'outcomes.' + outcome.id"
            >{{ outcome.value }}</span
          >
        </section>
      </foreignObject>
    }
  </svg>
</div>
